import { SpinnerGapIcon } from '@phosphor-icons/react';

export const LoadingOverlay = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
      <SpinnerGapIcon className="h-8 w-8 animate-spin text-[#0066B2]" />
    </div>
  );
};
